import { BACKEND_TYPES } from '../app/_helpers/urls';

/**
 * Vendor class is used to create configuration for different vendors.
 * Vendors are changed using `change_vendor.js` script in helper_scrips.
 * Run `npm run change_vendor` to change vendor.
 * Can be configured to run on jenkins itself.
 *
 * Vendor Themes are added to themes directory. File name be of type "vendor.theme.scss".
 * Themes must be imported into `styles.scss`. With a starting comment as following.
 *
 *          conf_block_start;
 *          conf_def:import_styles:<vendor name>
 *
 * and ending comment as following.
 *
 *          conf_block_end;
 *
 *
 * Typography are added to typography directory. File name be of type "vendor.typography.scss".
 *
 * @export
 */
export class Vendor {
    // Name of vendor
    name: string;

    // unique identification of vendor.
    loginSource: string;

    // Path of logo to be used.
    logoUrl: string;
    // Path of favicon to be used.
    favIcon?: string;
    // Any specific logo to be used for login. Defaults to logoUrl
    loginLogo?: string;
    // Background picture of login screen
    loginBackground: string;
    // Backend type of vendor. Can be of type "BACKEND_TYPES" specified in vendors.ts
    backendType: any;
    // In case captcha is supported
    hiddenRecaptchaKey?: string;
    // Path of directory containing vendor icons
    iconsPath: string;
    // Path of directory containing vendor images
    imgsPath: string;
    // Vendor's website link.
    websiteLink: string;
    // List of legal links
    legalLinks?: any[];
    // List of social platforms and their links of the vendor
    socialLinks?: any[];

    socialIcons?: any[];


    // Locale type of vendor, For ex: 'en-US', 'en-IN'
    locale: string;

    //version
    version: string;
    constructor(config: Vendor) {
        Object.assign(this, config);
    }
}

export const UtradePro = new Vendor({
    name: 'uTrade algos',
    loginSource: 'UtradePro',
    logoUrl: 'assets/images/UtradePro/logo_home.svg',
    iconsPath: 'assets/icons/UtradePro',
    imgsPath: 'assets/images/UtradePro',
    websiteLink: 'https://utradesolutions.com/',
    loginLogo: 'assets/images/UtradePro/uTrade.png',
    favIcon: 'assets/images/UtradePro/favicon.svg',
    loginBackground: 'assets/images/UtradePro/background.png',
    backendType: BACKEND_TYPES.AWS,
    locale: 'en-IN',
    version: '3.0.0.0 - E',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: 'https://twitter.com/utradealgos'
        },
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/utrade.algos'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/utrade.algos/'
        },
        {
            icon: 'linkedin',
            url: 'https://in.linkedin.com/company/utrade-algos'
        },
        {
            icon: 'youtube_red',
            url: 'https://www.youtube.com/@utradealgos'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        }
    ]
});

export const StratX = new Vendor({
    name: 'uTrade algos',
    loginSource: 'StratX',
    logoUrl: 'assets/images/UtradePro/logo_home.svg',
    iconsPath: 'assets/icons/UtradePro',
    imgsPath: 'assets/images/UtradePro',
    websiteLink: 'https://utradesolutions.com/',
    loginLogo: 'assets/images/UtradePro/uTrade.png',
    favIcon: 'assets/images/UtradePro/favicon.svg',
    loginBackground: 'assets/images/UtradePro/background.png',
    backendType: BACKEND_TYPES.AWS,
    locale: 'en-IN',
    version: '3.0.0.0 - E',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: 'https://twitter.com/utradealgos'
        },
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/utrade.algos'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/utrade.algos/'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        }
    ]
});


export const Swastika = new Vendor({
    name: 'uTrade algos',
    loginSource: 'Swastika',
    logoUrl: 'assets/images/UtradePro/logo_home.svg',
    iconsPath: 'assets/icons/UtradePro',
    imgsPath: 'assets/images/UtradePro',
    websiteLink: 'https://utradesolutions.com/',
    loginLogo: 'assets/images/UtradePro/uTrade.png',
    favIcon: 'assets/images/UtradePro/favicon.svg',
    loginBackground: 'assets/images/UtradePro/background.png',
    backendType: BACKEND_TYPES.AWS,
    locale: 'en-IN',
    version: '1.0.8',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: 'https://twitter.com/utradealgos'
        },
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/utrade.algos'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/utrade.algos/'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        }
    ]
});

export const Operator = new Vendor({
    name: 'Operator',
    loginSource: 'Operator',
    logoUrl: 'assets/images/UtradePro/logo_home.svg',
    iconsPath: 'assets/icons/UtradePro',
    imgsPath: 'assets/images/UtradePro',
    websiteLink: 'https://utradesolutions.com/',
    loginLogo: 'assets/images/UtradePro/uTrade.png',
    favIcon: 'assets/images/UtradePro/favicon.svg',
    loginBackground: 'assets/images/UtradePro/background.png',
    backendType: BACKEND_TYPES.AWS,
    locale: 'en-IN',
    version: '1.0.8',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: 'https://twitter.com/utradealgos'
        },
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/utrade.algos'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/utrade.algos/'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        }
    ]
});


export const Lynk = new Vendor({
    name: 'Lynk',
    loginSource: 'Lync',
    logoUrl: 'assets/images/lynk/logo.webp',
    iconsPath: 'assets/icons/lynk',
    imgsPath: 'assets/images/lynk',
    websiteLink: 'https://lynknetwork.com/',
    backendType: BACKEND_TYPES.AWS,
    loginBackground: 'assets/images/lynk/login-background.webp',
    locale: 'en-IN',
    version: '1.0.0.0',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: '#'
        },
        {
            icon: 'facebook',
            url: '#'
        },
        {
            icon: 'google',
            url: '#'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        },
        {
            name: 'Supported Brokers',
            url: '#'
        }
    ]
});

export const Mastertrust = new Vendor({
    name: 'uTrade algos',
    loginSource: 'Mastertrust',
    logoUrl: 'assets/images/UtradePro/logo_home.svg',
    iconsPath: 'assets/icons/UtradePro',
    imgsPath: 'assets/images/UtradePro',
    websiteLink: 'https://utradesolutions.com/',
    loginLogo: 'assets/images/UtradePro/uTrade.png',
    favIcon: 'assets/images/UtradePro/favicon.svg',
    loginBackground: 'assets/images/UtradePro/background.png',
    backendType: BACKEND_TYPES.AWS,
    locale: 'en-IN',
    version: '3.0.0.0',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: 'https://twitter.com/utradealgos'
        },
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/utrade.algos'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/utrade.algos/'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        }
    ]
})

export const Pesb = new Vendor({
    name: 'uTrade algos',
    loginSource: 'Pesb',
    logoUrl: 'assets/images/UtradePro/logo_home.svg',
    iconsPath: 'assets/icons/UtradePro',
    imgsPath: 'assets/images/UtradePro',
    websiteLink: 'https://utradesolutions.com/',
    loginLogo: 'assets/images/UtradePro/uTrade.png',
    favIcon: 'assets/images/UtradePro/favicon.svg',
    loginBackground: 'assets/images/UtradePro/background.png',
    backendType: BACKEND_TYPES.AWS,
    locale: 'en-IN',
    version: '1.0.8',
    socialLinks: [
        {
            icon: '/assets/images/UtradePro/app_store.svg',
            url: '#'
        },
        {
            icon: '/assets/images/UtradePro/play_store.svg',
            url: '#'
        },
    ],
    socialIcons: [
        {
            icon: 'twitter',
            url: 'https://twitter.com/utradealgos'
        },
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/utrade.algos'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/utrade.algos/'
        }
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            url: '/policies/privacy-policy'
        },
        {
            name: 'Terms of Use',
            url: '/policies/terms-of-use'
        }
    ]
});
